export default class Ui {
    constructor(logger) {
        this.logger = logger;
    }

    update(obj) {
        const playerElement = document.getElementById('player');
        this.logger.debug(obj);

        if (Object.prototype.hasOwnProperty.call(obj, 'backgroundImage')) {
            this.logger.info(`Update ui with new background image: ${obj.backgroundImage}`);
            playerElement.style.setProperty('--background-image', `url("${obj.backgroundImage}")`);
        }

        if (Object.prototype.hasOwnProperty.call(obj, 'splashImage')) {
            this.logger.info(`Update ui with new splash image: ${obj.backgroundImage}`);
            playerElement.style.setProperty('--splash-image', `url("${obj.splashImage}")`);
        }

        if (Object.prototype.hasOwnProperty.call(obj, 'logoImage')) {
            this.logger.info(`Update ui with new logo: ${obj.backgroundImage}`);
            playerElement.style.setProperty('--logo-image', `url("${obj.logoImage}")`);
        }

        if (Object.prototype.hasOwnProperty.call(obj, 'fontFamily')) {
            this.logger.info(`Update ui with new font family: ${obj.backgroundImage}`);
            playerElement.style.setProperty('--font-family', `url("${obj.fontFamily}")`);
        }
    }
}